import Vue from 'vue'
Vue.filter('moneyfilter', function (value, nullStr = '0.00') {
  if (!value) return nullStr
  var intPart = parseInt(value) // 获取整数部分
  var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
  var floatPart = '.00' // 预定义小数部分
  var value2Array = (value + '').split('.')
  // =2表示数据有小数位
  if (value.toString().indexOf('-') !== -1 && intPart === 0) {
    if (value2Array.length === 2) {
      floatPart = value2Array[1].toString() // 拿到小数部分
      if (floatPart.length === 1) { // 补0,实际上用不着
        return '-' + intPartFormat + '.' + floatPart + '0'
      } else {
        return '-' + intPartFormat + '.' + floatPart
      }
    } else {
      return '-' + intPartFormat + floatPart
    }
  } else {
    if (value2Array.length === 2) {
      floatPart = value2Array[1].toString() // 拿到小数部分
      if (floatPart.length === 1) { // 补0,实际上用不着
        return intPartFormat + '.' + floatPart + '0'
      } else {
        return intPartFormat + '.' + floatPart
      }
    } else {
      return intPartFormat + floatPart
    }
  }
})
// 这过滤器是为了处理收入流水订单金额为null，置空的情况。其他地方为null要置0
Vue.filter('moneyfilter1', function (value) {
  if (value === null) return '--'
  if (!value) return '0.00'
  var intPart = parseInt(value) // 获取整数部分
  var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
  var floatPart = '.00' // 预定义小数部分
  var value2Array = (value + '').split('.')
  // =2表示数据有小数位
  if (value.toString().indexOf('-') !== -1 && intPart === 0) {
    if (value2Array.length === 2) {
      floatPart = value2Array[1].toString() // 拿到小数部分
      if (floatPart.length === 1) { // 补0,实际上用不着
        return '-' + intPartFormat + '.' + floatPart + '0'
      } else {
        return '-' + intPartFormat + '.' + floatPart
      }
    } else {
      return '-' + intPartFormat + floatPart
    }
  } else {
    if (value2Array.length === 2) {
      floatPart = value2Array[1].toString() // 拿到小数部分
      if (floatPart.length === 1) { // 补0,实际上用不着
        return intPartFormat + '.' + floatPart + '0'
      } else {
        return intPartFormat + '.' + floatPart
      }
    } else {
      return intPartFormat + floatPart
    }
  }
})
Vue.filter('numberfilter', function (str) {
  var len = str.length - 6 - 4
  var xing = ''
  for (var i = 0; i < len; i++) {
    xing += '*'
  }
  return str.substring(0, 6) + xing + str.substring(str.length - 4)
})
// 银行卡4位空格过滤
Vue.filter('bandNumFilter', function (value) {
  if (value === undefined) {
    return ''
  }
  var v = value.toString()
  if (/\S{5}/.test(v)) {
    value = v.replace(/\s/g, '').replace(/(.{4})/g, '$1 ')
  }
  return value
})
// 整数千位
Vue.filter('intfilter', function (value) {
  if (!value) return '0'
  var intPart = Number(value).toFixed(0) // 获取整数部分
  var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
  return intPartFormat
})
// 手机号码
Vue.filter('phonefilter', function (value) {
  if (!value) return '--'
  var len = value.length
  var x = value.substring(3, len - 4)
  var values = value.replace(x, '****')
  return values
})



// WEBPACK FOOTER //
// ./src/utils/filters.js